export default {"src":"/_next/static/media/bice_vida_logo.e57e0b03.svg","height":20,"width":170,"blurWidth":0,"blurHeight":0};